import React from 'react';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { CountryFlag } from '../../country-flag/country-flag.js';
function CountryItem(props) {
    const { code, name, callingCode, style, onClick } = props;
    const onItemClick = () => {
        isFunction(onClick) && onClick({ callingCode, code, name });
    };
    return (React.createElement("div", { className: "c-phone-number-item", onClick: onItemClick, style: style },
        React.createElement(CountryFlag, { code: code }),
        React.createElement("span", { className: "c-phone-number-item__label" }, name),
        React.createElement("span", { className: "c-phone-number-item__calling-code" },
            "+",
            callingCode)));
}
export { CountryItem, };
//# sourceMappingURL=country-item.js.map